import React from 'react';
import { Link } from 'react-router';
import useTheme from '../hooks/useTheme';

interface PageHeroProps {
  title: string;
  subtitle: string;
  breadcrumbs?: Array<{ label: string; path?: string }>;
}

export const PageHero: React.FC<PageHeroProps> = ({ title, subtitle, breadcrumbs }) => {
  const { theme } = useTheme();
  return (
    <div
      style={{
        background: theme.gradients.hero,
        borderBottom: `1px solid ${theme.colors.border}`,
        paddingTop: '80px',
        paddingBottom: '48px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Blob shapes */}
      <div
        style={{
          position: 'absolute',
          top: '-100px',
          right: '-100px',
          width: '400px',
          height: '400px',
          borderRadius: '50%',
          background: `radial-gradient(circle, ${theme.colors.primary} 0%, transparent 70%)`,
          opacity: 0.12,
          filter: 'blur(60px)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '-100px',
          left: '-100px',
          width: '400px',
          height: '400px',
          borderRadius: '50%',
          background: `radial-gradient(circle, ${theme.colors.secondary} 0%, transparent 70%)`,
          opacity: 0.10,
          filter: 'blur(60px)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: '50%',
          right: '20%',
          width: '300px',
          height: '300px',
          borderRadius: '50%',
          background: `radial-gradient(circle, ${theme.colors.highlight} 0%, transparent 70%)`,
          opacity: 0.08,
          filter: 'blur(50px)',
        }}
      />
      
      <div
        style={{
          maxWidth: '1120px',
          margin: '0 auto',
          padding: '0 20px',
          position: 'relative',
          zIndex: 1,
        }}
      >
        {breadcrumbs && breadcrumbs.length > 0 && (
          <div
            style={{
              display: 'flex',
              gap: '8px',
              marginBottom: '16px',
              fontSize: '14px',
              color: theme.text.muted,
              flexWrap: 'wrap',
            }}
          >
            {breadcrumbs.map((crumb, idx) => (
              <React.Fragment key={idx}>
                {crumb.path ? (
                  <Link
                    to={crumb.path}
                    style={{
                      color: theme.text.muted,
                      textDecoration: 'none',
                    }}
                    className="breadcrumbLink"
                  >
                    {crumb.label}
                  </Link>
                ) : (
                  <span>{crumb.label}</span>
                )}
                {idx < breadcrumbs.length - 1 && <span> / </span>}
              </React.Fragment>
            ))}
          </div>
        )}
        <h1
          style={{
            fontSize: '46px',
            fontWeight: 700,
            color: theme.text.primary,
            marginBottom: '12px',
            lineHeight: 1.35,
          }}
          className="pageTitle"
        >
          {title}
        </h1>
        <p
          style={{
            fontSize: '18px',
            color: theme.text.muted,
            lineHeight: 1.6,
          }}
        >
          {subtitle}
        </p>
      </div>
    </div>
  );
};

